module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.8609/js/img/ServiceHub_Icon.svg"